import request from '@/api/request'
import { resolveRegistrationActivityAlias } from '@/registration/utils/registrationActivityAlias'
import { DEFAULT_MICROSITE_BROWSER_TITLE, resolveMicrositeBrowserTitle } from './pageBrowserTitle'

let active = null
let sequence = 0
export function micrositeTitleContext (route) {
  if (!String(route?.path || '').startsWith('/h5/')) return null
  const params = route.params || {}
  const query = route.query || {}
  if (Number.isInteger(Number(params.activityId)) && Number(params.activityId) > 0) {
    const activityId = Number(params.activityId)
    return { activityId: params.registrationId ? resolveRegistrationActivityAlias(activityId) : activityId }
  }
  if (params.pageId) return { pageId: String(params.pageId) }
  if (params.code && String(route.name || '').startsWith('Checkin')) return { checkinCode: String(params.code) }
  if (Number(params.registrationId || params.formId) > 0) return { registrationId: Number(params.registrationId || params.formId) }
  if (route.name === 'MicrositeEmbeddedLink') {
    if (typeof query.sourcePageId === 'string' && query.sourcePageId) return { pageId: query.sourcePageId }
    if (typeof query.returnTo === 'string') {
      const match = query.returnTo.match(/^\/h5\/([^/?#]+)(?:[?#]|$)/)
      if (match) {
        try { return { pageId: decodeURIComponent(match[1]) } } catch { return null }
      }
    }
  }
  return null
}
export function prepareActivityBrowserTitle (route) {
  sequence++
  const context = micrositeTitleContext(route)
  active = context ? { key: route.fullPath || route.path, context, title: DEFAULT_MICROSITE_BROWSER_TITLE } : null
}
export function activeActivityBrowserTitle (route) {
  if (!active || (route && active.key !== (route.fullPath || route.path))) return null
  return active.title
}
export async function syncActivityBrowserTitle (route) {
  const scope = active, revision = sequence
  if (!scope || scope.key !== (route.fullPath || route.path)) return
  document.title = scope.title
  try {
    const response = await request.get('/h5/browser-title', { params: scope.context, skipCompanyHeader: true, suppress404Toast: true })
    if (scope !== active || revision !== sequence) return
    scope.title = resolveMicrositeBrowserTitle(response?.data)
    document.title = scope.title
  } catch { /* A failed public metadata request keeps the generic brand title. */ }
}
